<template>
  <b-container
    tag="section"
    class="settings-cont messenger-settings">
    <b-row>
      <b-col
        sm="12"
        md="10"
        lg="8"
        offset-md="1"
        offset-lg="2"
        class="mb-5">
        <h1 class="messenger-settings-title">
          Business Information
        </h1>
        <img
          class="messenger-settings-social-logo"
          src="~@/assets/img/whatsapp.svg">
        <div class="messenger-settings-input-title messenger-settings-input-title--soc">
          Connect WhatsApp
        </div>
        <div class="messenger-settings-input-sub-title">
          Add WhatsApp phone number of your Business
        </div>
        <b-form class="messenger-settings-form">
          <b-input-group
            class="messenger-settings-input-group messenger-settings-input-group--soc"
            prepend="Phone">
            <div
              v-if="phoneCheck"
              slot="append"
              class="messenger-settings-input-checked">
              <img
                src="~@/assets/img/done.svg"
                alt="Done">
            </div>
            <b-input
              v-model.trim="phone"
              type="text"
              placeholder="+123456789"/>
          </b-input-group>
        </b-form>
        <img
          class="messenger-settings-social-logo"
          src="~@/assets/img/messenger.svg">
        <div class="messenger-settings-input-title messenger-settings-input-title--soc">
          Connect Messenger
        </div>
        <div class="messenger-settings-input-sub-title">
          Connect your Messenger account with AI Number
        </div>
        <b-form class="messenger-settings-form">
          <div
            role="group"
            class="input-group messenger-settings-input-group
            messenger-settings-input-group--soc">
            <div class="input-group-prepend">
              <div class="input-group-text">
                Facebook
              </div>
            </div>
            <div class="form-control messenger-settings-soc-btn">
              <img
                src="~@/assets/img/messenger-small.svg">
              <span>Connect Messenger</span>
            </div>
          </div>
        </b-form>
        <b-button class="messenger-settings-save">Save</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'MessengerSettings',
  data() {
    return {
      phone: '',
      fbMessenger: '',
    };
  },
  computed: {
    phoneCheck() {
      if (this.phone[0] === '+' && this.phone.length >= 6) {
        return true;
      }
      return false;
    },
  },
  methods: {
  },
};
</script>
